/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  if (document.querySelector('.template-product')) {
    var related = document.querySelectorAll('.related__products > div');
  
    var waitForClose = () => {
      var closeBtn = document.querySelector('.header.dismiss');
      if (!closeBtn) {
        setTimeout(waitForClose, 100);
        return;
      }
      closeBtn.addEventListener('click', () => {
        document.querySelector('body').style.overflow = 'unset';
        document.querySelector('.related__wrapper').style.visibility = 'visible';
        related.forEach((el) => {
          el.style.visibility = 'visible';
        });
      });
    }

    var waitForSuccess = () => {
      console.log("close")
      var closeBtn = document.querySelector('.message.success .dismiss');
      if (!closeBtn) {
        setTimeout(waitForSuccess, 100);
        return;
      }
      console.log(closeBtn);
      closeBtn.addEventListener('click', () => {
        console.log("file submitted");
      });
    }
    
    document.querySelector('.globo-formbuilder-open').addEventListener('click', () => {
      related.forEach((el) => {
        el.style.visibility = 'hidden';
      });
      document.querySelector('.related__wrapper ').style.visibility = 'hidden';
      document.querySelector('body').style.overflow = 'hidden';
  
      waitForClose();
      waitForSuccess();
    });  

  }
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
